module.exports = __webpack_public_path__ + "static/media/logisticsCover.509ece69.png";